import unitInfoContainer from './UnitInfoContainer.directive';

unitInfoPopupRoutesConfig.$inject = ['$stateProvider'];

export function unitInfoPopupRoutesConfig($stateProvider) {
  $stateProvider
    .state('unitinfo', {
      url: '/unitinfo',
      template: '<ui-view/>',
      views: {
        'unitinfo@': {
          template: () => `<div ${unitInfoContainer.htmlName}></div>`,
        },
      },
    })
    .state('unitinfo.view', {
      url: '/view/:id',
    });
}
